import Icon from 'vue-awesome/components/Icon'

Icon.register({
  screen_lock_rotation_sharp: {
    paths: [
      {
        d: 'M7.52 21.48A10.487 10.487 0 011.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.82-1.33 1.33zM20.05 4v-.36c0-1.31-.94-2.5-2.24-2.63a2.5 2.5 0 00-2.76 2.49V4h-1v6h7V4h-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4z'
      },
      {
        d: 'M19.73 11.2l-1.41 1.41 2.22 2.22-5.66 5.66L3.56 9.17l5.66-5.66 2.1 2.1 1.41-1.41L9.22.69.74 9.17l14.14 14.14 8.48-8.48z'
      }
    ],
    width: '24',
    height: '24'
  }
})
